import { useMutation } from "@tanstack/react-query";
import { Container } from "react-bootstrap";
import { FaCheck } from "react-icons/fa6";
import { RxCross1 } from "react-icons/rx";
import LoadingDots from "../../components/Loading";
import { getMethod } from "../../function/helper";
import style from "./CityInquiry.module.css";
import FilterCity from "./components/FilterCity";

function CityInquiry() {
  const { mutate, data, isPending } = useMutation({
    mutationKey: ["cities"],
    mutationFn: id =>
      getMethod("/address/v1/get-city", {
        id,
      }).then(res => {
        if (res && res.status === 200) {
          return res;
        }
      }),
  });

  return (
    <Container className="rtl-all mt-3">
      <h3 className="mb-0">استعلام شهر</h3>
      <p className="mb-5">
        می‌توانید برای بررسی فعال بودن سرویس دهنده ها در شهر مورد نظر، آن را
        جستجو کنید.
      </p>

      <FilterCity setCity={mutate} />

      {isPending && <LoadingDots />}
      {isPending === false && data !== undefined && (
        <div>
          <div className="mb-5">
            <span> استان: </span>
            <span className="fs-4 fw-semibold text-success">
              {data.city.province.faName + " "}
            </span>
            <span className="me-3">شهر: </span>
            <span className="fs-4 fw-semibold text-success">
              {data.city.faName}
            </span>
          </div>

          <h4>سرویس دهنده ها</h4>
          <hr />

          <ul className="d-flex flex-wrap justify-content-center column-gap-3">
            {data.companies.map(item => (
              <li key={item.id} className="list-unstyled">
                <div className={style.companyBox} style={{ height: 160 }}>
                  <div
                    className="d-flex justify-content-center"
                    style={{ height: 120 }}
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{ maxWidth: 110, objectFit: "contain" }}
                    />
                  </div>
                  <p className="text-center mt-auto mb-1 fs-small">
                    {item.name}
                  </p>
                </div>

                {item.isActiveForCity ? (
                  <div className="text-success text-center fs-5 fw-semibold">
                    <span className="ms-1">فعال</span>
                    <FaCheck />
                  </div>
                ) : (
                  <div className="text-danger text-center fs-5 fw-semibold">
                    <span className="ms-1">غیر فعال</span>
                    <RxCross1 />
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </Container>
  );
}

export default CityInquiry;
